import { useEffect, useRef } from "react";
import styles from "./light.module.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/src/ScrollTrigger";
import DOMPurify from "dompurify";
gsap.registerPlugin(ScrollTrigger);

const Light = ({ textData }) => {
  const brightnessElement = useRef(null);
  const temperatureElement = useRef(null);
  const renderingIndexElement = useRef(null);
  const headerBox1Ref = useRef(null);
  const headerBox2Ref = useRef(null);
  const productImg1Ref = useRef(null);
  const productImg2Ref = useRef(null);
  const effectSvgRef = useRef(null);
  const micVideoRef = useRef(null);
  const ctnRef = useRef(null);
  useEffect(() => {
    document.querySelectorAll(`.${styles.lightPath}`).forEach((item) => {
      item.style.setProperty("--length", `${item.getTotalLength()}px`);
    });
  }, []);
  useEffect(() => {
    let brightness = {
      value: 0,
    };
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        start: "top top",
        pin: true,
        pinSpacing: false,
        scrub: 1.5,
        end: "500%",
      },
    });

    tl.to(
      headerBox1Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      0
    );

    tl.to(
      headerBox1Ref.current,
      {
        "--color-offset-2": "100%",
        y: 0,
        duration: 4,
      },
      0
    );

    tl.to(
      headerBox1Ref.current,
      {
        transform: 'translateY(var(--wb3-size-effect-offset-y))',
        opacity: 0,
        duration: 2,
      },
      4
    );

    tl.to(
      headerBox2Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      6
    );

    tl.to(
      headerBox2Ref.current,
      {
        "--color-offset-2": "100%",
        y: 0,
        duration: 4,
      },
      6
    );

    tl.to(
      headerBox2Ref.current,
      {
        transform: 'translateY(var(--wb3-size-effect-offset-y))',
        opacity: 0,
        duration: 2,
      },
      10
    );

    tl.to(`.${styles.textBox1}`, {
      y: 0,
      opacity: 1,
      duration: 2,
    });

    tl.to(
      productImg2Ref.current,
      {
        opacity: 1,
        duration: 2,
      },
      10
    );

    tl.to(
      productImg1Ref.current,
      {
        opacity: 1,
        duration: 2,
      },
      10
    );

    tl.to(
      `.${styles.textBox1}`,
      {
        transform: 'translateY(var(--wb3-size-effect-offset-y))',
        opacity: 0,
        duration: 2,
      },
      14
    );

    tl.to(
      `.${styles.textBox2}`,
      {
        "--scaleX": 1,
        duration: 1,
      },
      15
    );

    tl.to(`.${styles.textBox2}`, {
      "--opacity": 1,
      duration: 1,
    });

    tl.to(
      `.${styles.textBox3}`,
      {
        "--scaleX": 1,
        duration: 1,
      },
      16
    );

    tl.to(`.${styles.textBox3}`, {
      "--opacity": 1,
      duration: 1,
    });

    tl.to(
      `.${styles.textBox2}`,
      {
        "--opacity": 0,
        "--scaleX": 0,
        duration: 1,
      },
      20
    );

    tl.to(
      `.${styles.textBox3}`,
      {
        "--opacity": 0,
        "--scaleX": 0,
        duration: 1,
      },
      21
    );

    tl.to(
      `.${styles.textBox4}`,
      {
        opacity: 1,
        y: 0,
        duration: 4,
      },
      22
    );

    tl.to(
      `.${styles.blur}`,
      {
        "--hue": 0,
        "--brightness": "100%",
        "--saturation": "0%",
        opacity: 1,
        duration: 2,
      },
      22
    );

    tl.to(
      `.${styles.blur2}`,
      {
        opacity: 1,
      },
      22
    );

    tl.to(
      `.${styles.textBox4}`,
      {
        opacity: 0,
        transform: 'translateY(var(--wb3-size-effect-offset-y))',
        duration: 4,
      },
      27
    );

    // tl.to(
    //   `.${styles.textBox5}`,
    //   {
    //     opacity: 1,
    //     y: 0,
    //     duration: 4,
    //   },
    //   32
    // );

    // tl.to(
    //   `.${styles.blur}`,
    //   {
    //     "--hue": 20,
    //     "--brightness": "80%",
    //     "--saturation": "99%",
    //     duration: 2,
    //   },
    //   32
    // );

    // tl.to(
    //   `.${styles.textBox5}`,
    //   {
    //     opacity: 0,
    //     transform: 'translateY(var(--wb3-size-effect-offset-y))',
    //     duration: 1,
    //   },
    //   36
    // );

    tl.to(
      `.${styles.textBox6}`,
      {
        opacity: 1,
        duration: 2,
      },
      32
    );

    tl.to(
      `.${styles.textBox6}`,
      {
        y: 0,
        duration: 7,
      },
      32
    );

    tl.to(
      `.${styles.blur}`,
      {
        "--hue": 0,
        "--brightness": "100%",
        "--saturation": "0%",
        duration: 2,
      },
      32.5
    );

    tl.to(
      `.${styles.lightPathBox}`,
      {
        opacity: 1,
        duration: 2,
        display: "block",
      },
      32.5
    );

    tl.to(
      `.${styles.lightPathBox}`,
      {
        opacity: 0,
        display: "none",
        duration: 4,
      },
      39
    );

    tl.to(
      `.${styles.textBox6}`,
      {
        opacity: 0,
        transform: 'translateY(var(--wb3-size-effect-offset-y))',
        duration: 2,
      },
      39
    );

    tl.to(
      `.${styles.textBox7}`,
      {
        opacity: 1,
        duration: 2,
      },
      43
    );

    tl.to(
      `.${styles.textBox7}`,
      {
        y: 0,
        duration: 4,
      },
      43
    );

    tl.to(
      productImg1Ref.current,
      {
        opacity: 0,
        duration: 2,
      },
      41
    );

    tl.to(
      effectSvgRef.current,
      {
        opacity: 0,
        display: "none",
        duration: 2,
      },
      41
    );

    tl.to(
      micVideoRef.current,
      {
        opacity: 1,
        duration: 2,
        y: 0,
      },
      49
    );

    tl.to(
      productImg1Ref.current,
      {
        opacity: 0,
        duration: 2,
      },
      49
    );

    tl.to(
      productImg2Ref.current,
      {
        opacity: 0,
        duration: 2,
      },
      49
    );

    tl.to(`.${styles.textBox7}`, {
      opacity: 1,
      y: 0,
      duration: 4,
    });
  });
  return (
    <div className={styles.ctn} ref={ctnRef}>
      <div className={`${styles.headerBox}`} ref={headerBox1Ref}>
        <h3
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text17"]),
          }}
        ></h3>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text18"]),
          }}
        ></h1>
      </div>

      <div className={`${styles.headerBox}`} ref={headerBox2Ref}>
        <h3
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text19"]),
          }}
        ></h3>
      </div>
      <h4
        className={`${styles.textBox} ${styles.textBox1}`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData["text20"]),
        }}
      ></h4>

      <div className={`${styles.textBox} ${styles.textBox2}`}>
        <div></div>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text21"]),
          }}
        ></h5>
      </div>

      <div className={`${styles.textBox} ${styles.textBox3}`}>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text22"]),
          }}
        ></h5>
        <div></div>
      </div>

      <div className={`${styles.textBox} ${styles.textBox4}`}>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text23"]),
          }}
        ></h5>

        <div className={styles.paramsBox}>
          <div className={styles.brightnessText}>
            <h5
              className="mainText"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text24"]),
              }}
            ></h5>
            <h2
              className={styles.brightnessValue}
              ref={brightnessElement}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text25"]),
              }}
            ></h2>
          </div>



          <div className={styles.renderingIndexText}>
            <h5
              className="mainText"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text28"]),
              }}
            ></h5>
            <h2
              className={styles.renderingIndexValue}
              ref={renderingIndexElement}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text29"]),
              }}
            ></h2>
          </div>

          <div className={styles.temperatureText}>
            <h5
              className="mainText"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text26"]),
              }}
            ></h5>
            <h2
              className={styles.temperatureValue}
              ref={temperatureElement}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData["text27"]),
              }}
            ></h2>
          </div>
        </div>
      </div>

      {/* <div className={`${styles.textBox} ${styles.textBox5}`}>

      </div> */}

      <div className={`${styles.textBox} ${styles.textBox6}`}>
        <h4
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text30"]),
          }}
        ></h4>
      </div>

      <div className={styles.mic}>
        <div className={`${styles.textBox} ${styles.textBox7}`}>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text31"]),
            }}
          ></h5>
        </div>
        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          className={styles.micVideo}
          src="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-6-1.mp4"
          poster="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-6-1-poster.jpg"
          ref={micVideoRef}
        />
      </div>

      <img
        src="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-5-3.jpg"
        alt="WEEBILL 3"
        ref={productImg2Ref}
      />
      <img
        src="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-5-2.jpg"
        alt="WEEBILL 3"
        ref={productImg1Ref}
      />

      <svg
        width="2560"
        height="1440"
        viewBox="0 0 2560 1440"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={effectSvgRef}
      >
        <g className={styles.lightBlurBox}>
          <radialGradient id="blur5-fill" cx="50%" cy="50%">
            <stop offset="0%" stopColor="rgba(255, 255, 255, 0.2)"></stop>
            <stop offset="100%" stopColor="rgba(255, 255, 255, 0)"></stop>
          </radialGradient>
          <filter id="blur1">
            <feGaussianBlur stdDeviation="8" />
          </filter>
          <filter id="blur2" x="-200%" y="-200%" width="800%" height="800%">
            <feGaussianBlur stdDeviation="20" />
          </filter>

          <filter id="blur3" x="-400%" y="-400%" width="800%" height="800%">
            <feGaussianBlur stdDeviation="32" />
          </filter>

          <filter id="blur4" x="-400%" y="-400%" width="1000%" height="1000%">
            <feGaussianBlur stdDeviation="96" />
          </filter>
          <rect
            className={styles.blur}
            x="49%"
            y="44.1%"
            width="52.8"
            rx="10"
            height="155"
            filter="url(#blur1)"
          />
          <rect
            className={styles.blur}
            x="49%"
            y="44.1%"
            width="52.8"
            rx="10"
            height="155"
            filter="url(#blur2)"
          />
          <rect
            className={styles.blur}
            x="48.8%"
            y="42.6%"
            width="66"
            rx="10"
            height="196"
            filter="url(#blur3)"
          />
          <rect
            className={styles.blur}
            x="48.1%"
            y="40.3%"
            width="96"
            rx="10"
            height="282"
            filter="url(#blur4)"
          />
          <rect
            className={styles.blur2}
            x="30%"
            y="10%"
            width="1048"
            rx="10"
            height="1166"
            fill="url(#blur5-fill)"
          />
        </g>

        <g className={styles.lightPathBox}>
          <g opacity="0.4" filter="url(#filter0_f_3056_58098)">
            <path
              d="M1345.91 553C1355.98 625.95 1319.91 670.88 1319.91 670.88V765.087C1319.91 765.087 1353.46 794.073 1341.72 882C1452.46 796.006 1550.2 694.552 1345.91 553Z"
              fill="url(#paint0_linear_3056_58098)"
            />
          </g>
          <g filter="url(#filter1_f_3056_58098)">
            <path
              d="M1317.91 755C1317.91 755 1366.41 781.5 1378.91 871"
              stroke="url(#paint1_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter2_f_3056_58098)">
            <path
              d="M1325.41 739C1325.41 739 1384.91 754 1428.91 804"
              stroke="url(#paint2_linear_3056_58098)"
              stroke-width="3"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter3_f_3056_58098)">
            <path
              d="M1315.31 745.417C1315.31 745.417 1400.41 773.5 1442.91 881.501"
              stroke="url(#paint3_linear_3056_58098)"
              stroke-width="8"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter4_f_3056_58098)">
            <path
              d="M1320.91 727.426C1320.91 727.426 1435.41 743.5 1481.41 803"
              stroke="url(#paint4_linear_3056_58098)"
              stroke-width="8"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter5_f_3056_58098)">
            <path
              d="M1315.41 719C1315.41 719 1410.91 724 1458.41 744.5"
              stroke="url(#paint5_linear_3056_58098)"
              stroke-width="2"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter6_f_3056_58098)">
            <path
              d="M1317.91 680.841C1317.91 680.841 1366.41 654.341 1378.91 564.841"
              stroke="url(#paint6_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter7_f_3056_58098)">
            <path
              d="M1323.41 696.841C1323.41 696.841 1382.91 681.841 1426.91 631.841"
              stroke="url(#paint7_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter8_f_3056_58098)">
            <path
              d="M1315.31 689.425C1315.31 689.425 1400.41 661.341 1442.91 553.341"
              stroke="url(#paint8_linear_3056_58098)"
              stroke-width="8"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter9_f_3056_58098)">
            <path
              d="M1322.91 705.415C1322.91 705.415 1429.41 693 1465.41 638.5"
              stroke="url(#paint9_linear_3056_58098)"
              stroke-width="10"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter10_f_3056_58098)">
            <path
              d="M1327.41 710.5C1327.41 710.5 1400.91 719.999 1456.91 684"
              stroke="url(#paint10_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter11_f_3056_58098)">
            <path
              d="M1319.41 675C1319.41 675 1358.41 620 1339.91 535"
              stroke="url(#paint11_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g opacity="0.4" filter="url(#filter12_f_3056_58098)">
            <path
              d="M1216.09 553C1206.02 625.95 1242.09 670.88 1242.09 670.88V765.087C1242.09 765.087 1208.54 794.073 1220.28 882C1109.54 796.006 1011.8 694.552 1216.09 553Z"
              fill="url(#paint12_linear_3056_58098)"
            />
          </g>
          <g filter="url(#filter13_f_3056_58098)">
            <path
              d="M1244.09 755C1244.09 755 1195.59 781.5 1183.09 871"
              stroke="url(#paint13_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter14_f_3056_58098)">
            <path
              d="M1236.59 739C1236.59 739 1177.09 754 1133.09 804"
              stroke="url(#paint14_linear_3056_58098)"
              stroke-width="3"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter15_f_3056_58098)">
            <path
              d="M1246.69 745.417C1246.69 745.417 1161.59 773.5 1119.09 881.501"
              stroke="url(#paint15_linear_3056_58098)"
              stroke-width="8"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter16_f_3056_58098)">
            <path
              d="M1241.09 727.426C1241.09 727.426 1126.59 743.5 1080.59 803"
              stroke="url(#paint16_linear_3056_58098)"
              stroke-width="8"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter17_f_3056_58098)">
            <path
              d="M1246.59 719C1246.59 719 1151.09 724 1103.59 744.5"
              stroke="url(#paint17_linear_3056_58098)"
              stroke-width="2"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter18_f_3056_58098)">
            <path
              d="M1244.09 680.841C1244.09 680.841 1195.59 654.341 1183.09 564.841"
              stroke="url(#paint18_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter19_f_3056_58098)">
            <path
              d="M1238.59 696.841C1238.59 696.841 1179.09 681.841 1135.09 631.841"
              stroke="url(#paint19_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter20_f_3056_58098)">
            <path
              d="M1246.69 689.425C1246.69 689.425 1161.59 661.341 1119.09 553.341"
              stroke="url(#paint20_linear_3056_58098)"
              stroke-width="8"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter21_f_3056_58098)">
            <path
              d="M1239.09 705.415C1239.09 705.415 1132.59 693 1096.59 638.5"
              stroke="url(#paint21_linear_3056_58098)"
              stroke-width="10"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter22_f_3056_58098)">
            <path
              d="M1234.59 710.5C1234.59 710.5 1161.09 719.999 1105.09 684"
              stroke="url(#paint22_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <g filter="url(#filter23_f_3056_58098)">
            <path
              d="M1242.59 675C1242.59 675 1203.59 620 1222.09 535"
              stroke="url(#paint23_linear_3056_58098)"
              stroke-width="4"
              className={styles.lightPath}
            />
          </g>
          <defs>
            <filter
              id="filter0_f_3056_58098"
              x="1239.91"
              y="473"
              width="305"
              height="489"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="40"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter1_f_3056_58098"
              x="1308.94"
              y="745.246"
              width="79.9414"
              height="134.03"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter2_f_3056_58098"
              x="1317.04"
              y="729.546"
              width="120.993"
              height="83.4453"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter3_f_3056_58098"
              x="1306.05"
              y="733.62"
              width="148.575"
              height="157.346"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter4_f_3056_58098"
              x="1312.35"
              y="715.465"
              width="180.222"
              height="97.9814"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter5_f_3056_58098"
              x="1307.35"
              y="710.001"
              width="159.447"
              height="43.417"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter6_f_3056_58098"
              x="1308.94"
              y="556.564"
              width="79.9414"
              height="134.03"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter7_f_3056_58098"
              x="1314.92"
              y="622.52"
              width="121.49"
              height="84.2598"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter8_f_3056_58098"
              x="1306.05"
              y="543.876"
              width="148.575"
              height="157.346"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter9_f_3056_58098"
              x="1314.33"
              y="627.744"
              width="163.252"
              height="90.6367"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter10_f_3056_58098"
              x="1319.15"
              y="674.317"
              width="146.836"
              height="47.3164"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter11_f_3056_58098"
              x="1309.77"
              y="526.574"
              width="45.1123"
              height="157.58"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter12_f_3056_58098"
              x="1017.09"
              y="473"
              width="305"
              height="489"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="40"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter13_f_3056_58098"
              x="1173.11"
              y="745.246"
              width="79.9424"
              height="134.03"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter14_f_3056_58098"
              x="1123.97"
              y="729.546"
              width="120.993"
              height="83.4453"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter15_f_3056_58098"
              x="1107.37"
              y="733.62"
              width="148.575"
              height="157.346"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter16_f_3056_58098"
              x="1069.43"
              y="715.465"
              width="180.221"
              height="97.9814"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter17_f_3056_58098"
              x="1095.2"
              y="710.001"
              width="159.448"
              height="43.417"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter18_f_3056_58098"
              x="1173.11"
              y="556.564"
              width="79.9424"
              height="134.03"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter19_f_3056_58098"
              x="1125.59"
              y="622.52"
              width="121.491"
              height="84.2598"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter20_f_3056_58098"
              x="1107.37"
              y="543.876"
              width="148.575"
              height="157.346"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter21_f_3056_58098"
              x="1084.42"
              y="627.744"
              width="163.252"
              height="90.6367"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter22_f_3056_58098"
              x="1096.01"
              y="674.317"
              width="146.836"
              height="47.3164"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <filter
              id="filter23_f_3056_58098"
              x="1207.11"
              y="526.574"
              width="45.1123"
              height="157.58"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_3056_58098"
              />
            </filter>
            <linearGradient
              id="paint0_linear_3056_58098"
              x1="1316.55"
              y1="693.103"
              x2="1440.98"
              y2="697.852"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_3056_58098"
              x1="1378.91"
              y1="865"
              x2="1298.25"
              y2="777.073"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_3056_58098"
              x1="1421.41"
              y1="798.5"
              x2="1337.92"
              y2="724.348"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_3056_58098"
              x1="1429.41"
              y1="860.5"
              x2="1321.69"
              y2="747.229"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_3056_58098"
              x1="1469.91"
              y1="800"
              x2="1342.78"
              y2="699.37"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_3056_58098"
              x1="1450.91"
              y1="739.5"
              x2="1337.06"
              y2="693.088"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_3056_58098"
              x1="1375.91"
              y1="562"
              x2="1296.27"
              y2="658.992"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_3056_58098"
              x1="1426.91"
              y1="631.841"
              x2="1337.08"
              y2="712.605"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_3056_58098"
              x1="1441.91"
              y1="562.5"
              x2="1318.68"
              y2="688.96"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_3056_58098"
              x1="1464.91"
              y1="638"
              x2="1343.39"
              y2="732.25"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_3056_58098"
              x1="1476.41"
              y1="679.5"
              x2="1340.42"
              y2="741.257"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_3056_58098"
              x1="1345.91"
              y1="535"
              x2="1269.25"
              y2="589.391"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_3056_58098"
              x1="1245.45"
              y1="693.103"
              x2="1121.02"
              y2="697.852"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_3056_58098"
              x1="1183.09"
              y1="865"
              x2="1263.75"
              y2="777.073"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_3056_58098"
              x1="1140.59"
              y1="798.5"
              x2="1224.08"
              y2="724.348"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_3056_58098"
              x1="1132.59"
              y1="860.5"
              x2="1240.31"
              y2="747.229"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint16_linear_3056_58098"
              x1="1092.09"
              y1="800"
              x2="1219.22"
              y2="699.37"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint17_linear_3056_58098"
              x1="1111.09"
              y1="739.5"
              x2="1224.94"
              y2="693.088"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint18_linear_3056_58098"
              x1="1186.09"
              y1="562"
              x2="1265.73"
              y2="658.992"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint19_linear_3056_58098"
              x1="1135.09"
              y1="631.841"
              x2="1224.92"
              y2="712.605"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint20_linear_3056_58098"
              x1="1120.09"
              y1="562.5"
              x2="1243.32"
              y2="688.96"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint21_linear_3056_58098"
              x1="1097.09"
              y1="638"
              x2="1218.61"
              y2="732.25"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint22_linear_3056_58098"
              x1="1085.59"
              y1="679.5"
              x2="1221.58"
              y2="741.257"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint23_linear_3056_58098"
              x1="1216.09"
              y1="535"
              x2="1292.75"
              y2="589.391"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-opacity="0" />
              <stop offset="0.296875" stop-opacity="0.2" />
              <stop offset="0.682292" />
              <stop offset="1" stop-opacity="0" />
            </linearGradient>
          </defs>
        </g>
      </svg>
    </div>
  );
};

export default Light;
